import { store } from '@/vuex/store'
import axios from 'axios'
const empty_params = { params: {} }

const setHeader = function () {
    // axios.get(url,config)
    // axios.post(url, data, config);
    // axios.put(url, data, config);
    // axios.delete(url, config);
    const headers = { authorization: `Bearer ${store.state.aToken}`, locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'hr' }
    return { headers }
}

const axiosGet = function (url, params = empty_params) {
    return axios.get(url, {
        params:
            params.params
        ,
        headers: {
            authorization: `Bearer ${store.state.aToken}`,
            locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'hr'
        }
    })
}
const axiosDelete = function (url, params = empty_params) {
    return axios.delete(url, {
        params:
            params.params
        ,
        headers: {
            authorization: `Bearer ${store.state.aToken}`,
            locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'hr'
        }
    })
}

const axiosPost = function (url, params = empty_params) {
    console.log(params)
    if (params.params != undefined) {
        return axios.post(url, {
            params:
                params.params
        }, {
            headers: {
                authorization: `Bearer ${store.state.aToken}`,
                locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'hr'
            }
        })
    } else {
        return axios.post(url, params, {
            headers: {
                authorization: `Bearer ${store.state.aToken}`,
                locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'hr'
            }
        })
    }

}

const axiosPut = function (url, params = empty_params) {
    if (params.params != undefined) {
        return axios.put(url, {
            params:
                params.params
        }, {
            headers: {
                authorization: `Bearer ${store.state.aToken}`,
                locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'hr'
            }
        })
    } else {
        return axios.put(url, params, {
            headers: {
                authorization: `Bearer ${store.state.aToken}`,
                locale: localStorage.getItem("lang") ? localStorage.getItem("lang") : 'hr'
            }
        })
    }
}

export {
    setHeader, axiosGet, axiosDelete, axiosPut, axiosPost
}